import React from "react";
import PropTypes from "prop-types";
import DashboardComparisonBadge from "./DashboardComparisonBadge";

const DashboardKpiCard = ({ icon, label, value, comparison, comparisonFormatter, comparisonLabel }) => (
    <div className="dashboard-kpi-card">
        <div className="dashboard-kpi-label">
            {icon}
            <span>{label}</span>
        </div>
        <div className="dashboard-kpi-value">{value}</div>
        {comparisonLabel && (
            <div className="dashboard-kpi-sub">
                <DashboardComparisonBadge comparison={comparison} formatComparison={comparisonFormatter} />
                <span>{comparisonLabel}</span>
            </div>
        )}
    </div>
);

DashboardKpiCard.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    comparison: PropTypes.object,
    comparisonFormatter: PropTypes.func.isRequired,
    comparisonLabel: PropTypes.string
};

DashboardKpiCard.defaultProps = {
    comparison: null,
    comparisonLabel: ""
};

export default DashboardKpiCard;
